import * as React from 'react';
import { createRoot } from 'react-dom/client';

import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
// import Bs4ViewTime from '../Bs4Components/Bs4ViewTimeOld'
import Bs4ViewTime from '../Bs4Components/Bs4ViewTime'
import Bs4MainDispatch from '../Bs4MainDispatch'
import * as Bs4Utils from '../Bs4Components/Bs4Utils'
import {isNullOrNaN} from '../Bs4Components/Bs4Utils';

const getDateTime = (value) => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  const t = d.getTime();
  return Bs4Utils.getValidDate(t + parseInt(value * 1000));
}

const getFloat = (dateTime) => {
  try {
    return 60 * 60 * dateTime.getHours() + 60 * dateTime.getMinutes() + dateTime.getSeconds();
  } catch(error) {
    //console.log('...Bs4ColumnsTime...getFloat...', error);  
    //console.log(error);     
    return 0;
  }
  return null;
}

export const getTime = (valueTime) => {
  const value = parseInt(valueTime);
  if (isNullOrNaN(value)) return '';
  const s = value % 60;
  const mv = (value - s) / 60;
  const m = mv % 60;
  const h = (mv - m) / 60;
  let mStr = String(m);   
  while (mStr.length < 2) mStr = '0'+mStr;
  let hStr = String(h);   
  while (hStr.length < 2) hStr = '0'+hStr;
  return hStr+':'+mStr;
}

export const formatterTime = (cell, formatterParams, onRendered) => {
  return getTime(cell.getValue());
  // return Bs4Utils.toTimeMinutes(getDateTime(cell.getValue()));
}

const isRowInFooter = (element, level) => {  
  if (!level) level = 0
  if (level > 3) return false;
  if (element?.className?.includes('tabulator-footer')) return true;
  if (element?.parentElement) return isRowInFooter(element.parentElement, level+1)
  return false;
}

export const formatterSumTimeOld = (cell, formatterParams, onRendered) => {
  const footer = isRowInFooter(cell.getRow().getElement())

  const value = cell.getValue();
  const bs4Totals = formatterParams.bs4Totals();
  const column = cell.getColumn();
  const field = column.getField();
  let total = null;
  if (bs4Totals) total = bs4Totals[field];
  // return Bs4Utils.toTimeMinutes(getDateTime(cell.getValue()));

  const value1 = getTime(value);
  const total1 = getTime(total);

  // 2025-01-28 61453 – Podsumowanie zaznaczonych wierszy [Core]
  const tabulator = cell.getRow().getTable();
  const selectedData = tabulator.getSelectedData();
  const selectedSumValue = getTime(selectedData.reduce((valueSum, data) => valueSum + parseInt(data[field]), 0));

  if (total && footer && bs4Totals.lastPage > 1) {        
    if (selectedData.length > 0) {
      return `<span>${value1}</span><br/><span>${total1}</span><br/><span>(${selectedData.length}) ${selectedSumValue}</span>`;
    }

    return `<span>${value1}</span><br/><span>${total1}</span>`;
  }

  if (selectedData.length > 0) {
    return `<span>${value1}</span><br/><span>(${selectedData.length}) ${selectedSumValue}</span>`;
  }
  
  return value1;
}

export const formatterSumTime = function(cell, formatterParams, onRendered) {  
  const span = document.createElement('span');  
  const root = createRoot(span);  
  root.render(
    <Bs4SumTime
      cell={cell} 
      formatterParams={formatterParams}
    />        
  )

  onRendered(() => {    
    const lines = getHeight({cell, formatterParams})
    cell.getElement().style.height = (lines * 19)+'px';    
  })

  return span;  
}

const Bs4TooltipTitle = (props) => {

  return (
    <span style={{wordSpacing: 'normal'}}>
      <span>razem</span> <span style={{fontWeight: 'bold'}}>{props.columnName}</span> <span>({props.type})</span>
    </span>
  )
}

const Bs4SumTime = (props) => {
  const {cell, formatterParams} = props;
  const ref = React.useRef(null);
  const views = React.useMemo(() => {
    const footer = isRowInFooter(cell.getRow().getElement())

    const value = cell.getValue();
    const bs4Totals = formatterParams.bs4Totals();
    const column = cell.getColumn();
    const field = column.getField();
    let total = null;
    if (bs4Totals) total = bs4Totals[field];

    const value1 = getTime(value);
    const total1 = getTime(total);

    // 2025-01-28 61453 – Podsumowanie zaznaczonych wierszy [Core]
    const tabulator = cell.getRow().getTable();
    const selectedData = tabulator.getSelectedData();
    const selectedSumValue = getTime(selectedData.reduce((valueSum, data) => valueSum + parseInt(data[field]), 0));

    const name = column.getDefinition().title;
    // "razem [nazwa kolumny] (strona/zestawienie/zaznaczone):"   
    const views = [(
      <Tooltip placement='top' arrow title={<Bs4TooltipTitle columnName={name} type='strona'/>}>
        <span>{value1}</span>
      </Tooltip>
    )]

    if (total && footer && bs4Totals.lastPage > 1) {
      views.push(
        <Tooltip placement='top' arrow title={<Bs4TooltipTitle columnName={name} type='zestawienie'/>}>
          <br/><span>{total1}</span>
        </Tooltip>
      );
    }

    if (selectedData.length > 0) {
      views.push(
        <Tooltip placement='top' arrow title={<Bs4TooltipTitle columnName={name} type='zaznaczone'/>}>
          <br/><span>({selectedData.length}) {selectedSumValue}</span>
        </Tooltip>
      );        
    }    

    return views;
  }, [cell, formatterParams]);

  return (
    <React.Fragment>
      {views.map((view, index) => {
         return <React.Fragment key={index}>{view}</React.Fragment>
      })}
    </React.Fragment>
  )
}

const getHeight = (props) => {
  const {cell, formatterParams} = props;
  const footer = isRowInFooter(cell.getRow().getElement())
  const bs4Totals = formatterParams.bs4Totals();
  const column = cell.getColumn();
  const field = column.getField();
  let total = null;
  if (bs4Totals) total = bs4Totals[field];
  
  const tabulator = cell.getRow().getTable();
  const selectedData = tabulator.getSelectedData();

  let lines = 1;
  if (total && footer && bs4Totals.lastPage > 1) lines++;
  if (selectedData.length > 0) lines++;

  return lines;
}

export function editorTime(cell, onRendered, success, cancel, editorParams) {
  const editor = document.createElement("div");
  const styleBorder = cell.getElement().style.border
  cell.getElement().style.border = 'none';

  const root = createRoot(editor);

  const bs4Success = (value) => {
    cell.getElement().style.border = styleBorder;
    try {
      root.unmount();
    } catch (error) {
      console.log('unmout error', error)
    }  
    const newValue = getFloat(value);
    if (cell.getValue() === newValue) cancel();
    else success(newValue);
  }

  onRendered(() => {
    root.render(
      <ViewComponentTime
        value={getDateTime(cell.getValue())}
        editorParams={editorParams}
        bs4Success={bs4Success}
        cancel={cancel}
        cell={cell}
      />);
  });

  return editor;
}

const ViewComponentTime = (props) => {
  const [value, setValue] = React.useState(props.value);
  const inputRef = React.useRef(null);
  const valueRef = React.useRef(props.value);

  const onchange = (newValue) => {    
    valueRef.current = newValue;
    setValue(newValue);
    // console.log('...Bs4ColumnsTime...change...', newValue, valueRef.current);  
  }

  const handLeleaveField = () => {
    // console.log('...Bs4ColumnsTime...LeleaveField...', value, valueRef.current);  
    props.bs4Success(valueRef.current);
  }

  const onKeyDownTextField = (e) => {
    console.log('...Bs4ColumnsTime...Key...', e);  
    switch (e.keyCode) {
      case 13: //Enter
        props.bs4Success(valueRef.current);
        break;

      case 9: //Tab
        break;

      case 27:  //Esc
        props.cancel();
        break;

      case 38: //up arrow
      case 40: //down arrow
        // if (props?.editorParams?.verticalNavigation == "editor") {
        //   if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        //   e.stopPropagation();
        // }
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        e.stopPropagation();
        // if (e.preventDefault) e.preventDefault()
        break;

      case 35:
      case 36:
        e.stopPropagation();
        break;
    }
  }

  React.useEffect(() => {
    if (props.cell?.getRow()) props.cell.getRow().normalizeHeight()
  }, [props.cell]);

  React.useEffect(() => {
    inputRef.current?.focus();
  }, [inputRef.current]);

  console.log('...Bs4ColumnsTime...', props);   
  
  const [xx, xxXX] = Bs4MainDispatch.useBs4Locale();

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={xx}
      localeText={xxXX.components.MuiLocalizationProvider.defaultProps.localeText}
    >
      <Box overflow={'hidden'}>
        <Bs4ViewTime
          inputRef={inputRef}
          value={value}
          fullWidth
          onChange={(newValue) => onchange(newValue)}
          onLeaveField={handLeleaveField}
          timeStep={parseInt(props.editorParams?.min_interval) || 5} 
          slotProps={{
            textField: {
              autoFocus: true,
              margin: 'dense',
              size: 'small',              
              variant: "outlined",
              sx: { mt: '2px', mb: '1px', my: '1px', '& input': { padding: 0.5 } },
              onKeyDown: onKeyDownTextField,              
            }
          }}
        />
      </Box>
    </LocalizationProvider>
  );
}